export const BehaviorDescription: any = {
  iniciativa: 'Buscar/propor melhorias, apresentar novas soluções/tecnologias, solução simples também é inovadora.',
  cooperacao: 'Trabalho em equipe, disponibilidade, disposição a ensinar e aprender, comunicação assertiva.',
  integridade: 'Qualidade da entrega, rapidez no atendimento (cumprimento de prazos), satisfação do cliente.',
  lideranca:
    'Conquistar o time, ser motivador, ter gentileza e empatia. Liderança não é apenas para gestores, todos podem inspirar o time.',
};

export const BehaviorText: any = {
  iniciativa: `Inovar é trazer algo novo ou executar uma ação que nunca foi realizada antes. Significa encontrar soluções, até mesmo as mais simples, para os desafios diários. Essa capacidade de inovar pode transformar a empresa, a equipe, o mercado - ou até mesmo o mundo.
  Já reparou naquele colega que apresentou uma ideia brilhante para simplificar o dia a dia ou solucionar um problema complicado? Reconhecê-lo no Reconheça BRB é também uma forma de inovar. Vamos valorizar essa atitude?
  <br /><br />
  <span class="text-yellow text-light">Estamos sempre em busca do novo.</span>
  <br /><br />
  <span class="text-yellow text-light">Representamos evolução e inovação.</span>
  `,
  cooperacao: `A cooperação é fundamental para que todos se conectem de forma <a class="text-yellow hover:text-yellow" href="https://blog.betrybe.com/carreira/pensamento-sistemico/" target="_blank">harmônica</a>, impulsionando o crescimento coletivo da equipe. Quando trabalhamos juntos, os obstáculos parecem menores e os objetivos são atingidos com mais rapidez e eficácia.
  <br /><br />
  Imagine que, em uma semana de trabalho intensa, você conta com o apoio de um colega disposto a ajudar. Esse é o verdadeiro espírito colaborativo! Que tal acessar o Reconheça BRB para reconhecer essa atitude?
  <br /><br />
  <span class="text-yellow text-light">Enfrentamos desafios e geramos resultados</span>
  `,
  integridade: `Colocar o cliente no centro significa oferecer um atendimento humanizado, demonstrando empatia e proporcionando soluções que atendam às necessidades específicas, sempre com rapidez e eficiência.
  Se um colega brilhou ao encantar um cliente com um atendimento exemplar, ele merece ser reconhecido no Reconheça BRB!
  <br /><br />
  <span class="text-yellow text-light">Nossa meta é entregar valor ao cliente.</span>
  <br /><br />
  <span class="text-yellow text-light">Construímos relações de longo prazo baseadas no respeito e na qualidade.</span>
  `,
  lideranca: `
  Valorizar as diferenças, reconhecer a individualidade e fomentar uma comunicação aberta são atitudes essenciais.
  <br /><br />
  Você conhece um líder que inspira com essas qualidades? Ele certamente merece um reconhecimento especial!
  <br /><br />
  <span class="text-yellow text-light">Empatia e gentileza criam conexões verdadeiras</span>
  <br /><br />
  <span class="text-yellow text-light">Incentivamos o ser autêntico</span>
  <br /><br />
  <span class="text-yellow text-light">Relações duradouras se constroem com respeito</span>
  `,
};

export const BehaviorTextDestaque: any = {
  iniciativa: `Inovar é trazer algo novo ou executar uma ação que nunca foi realizada antes. Significa encontrar soluções, até mesmo as mais simples, para os desafios diários. Essa capacidade de inovar pode transformar a empresa, a equipe, o mercado - ou até mesmo o mundo.
  Já reparou naquele colega que apresentou uma ideia brilhante para simplificar o dia a dia ou solucionar um problema complicado? Reconhecê-lo no Reconheça BRB é também uma forma de inovar. Vamos valorizar essa atitude?
  <br /><br />
  <span class="text-yellow text-light">Estamos sempre em busca do novo.</span>
  <br /><br />
  <span class="text-yellow text-light">Representamos evolução e inovação.</span>
  `,
  cooperacao: `A cooperação é fundamental para que todos se conectem de forma <a class="text-yellow hover:text-yellow" href="https://blog.betrybe.com/carreira/pensamento-sistemico/" target="_blank">harmônica</a>, impulsionando o crescimento coletivo da equipe. Quando trabalhamos juntos, os obstáculos parecem menores e os objetivos são atingidos com mais rapidez e eficácia.
  <br /><br />
  Imagine que, em uma semana de trabalho intensa, você conta com o apoio de um colega disposto a ajudar. Esse é o verdadeiro espírito colaborativo! Que tal acessar o Reconheça BRB para reconhecer essa atitude?
  <br /><br />
  <span class="text-yellow text-light">Enfrentamos desafios e geramos resultados</span>
  `,
  integridade: `Colocar o cliente no centro significa oferecer um atendimento humanizado, demonstrando empatia e proporcionando soluções que atendam às necessidades específicas, sempre com rapidez e eficiência.
  Se um colega brilhou ao encantar um cliente com um atendimento exemplar, ele merece ser reconhecido no Reconheça BRB!
  <br /><br />
  <span class="text-yellow text-light">Nossa meta é entregar valor ao cliente.</span>
  <br /><br />
  <span class="text-yellow text-light">Construímos relações de longo prazo baseadas no respeito e na qualidade.</span>
  `,
  lideranca: `
  Valorizar as diferenças, reconhecer a individualidade e fomentar uma comunicação aberta são atitudes essenciais.
  <br /><br />
  Você conhece um líder que inspira com essas qualidades? Ele certamente merece um reconhecimento especial!
  <br /><br />
  <span class="text-yellow text-light">Empatia e gentileza criam conexões verdadeiras</span>
  <br /><br />
  <span class="text-yellow text-light">Incentivamos o ser autêntico</span>
  <br /><br />
  <span class="text-yellow text-light">Relações duradouras se constroem com respeito</span>
  `,
};

export const MoedaDescription: any = {
  uau: 'É o reconhecimento mais valioso e deve ser utilizado ao perceber que o comportamento apresentado foi extraordinário, de tal forma a se tornar uma referência e inspiração.',
  mandou:
    'Esse reconhecimento deve ser enviado ao perceber um comportamento ou realização com nível de excelência, que supere significativamente as expectativas.',
  valeu: 'Deve ser usado ao perceber um comportamento ou realização relevante e de qualidade. ',
  uau_task: 'Comportamento ou entrega extraordinária, ou seja, para uma referência ou inspiração',
  mandou_task: 'Comportamento ou entrega que superou significativamente as expectativas',
  valeu_task: 'Comportamento ou entrega de nível excelente',
};

export const BehaviorLabel: any = {
  iniciativa: 'Iniciativa',
  cooperacao: 'Cooperação',
  integridade: 'Integridade',
  lideranca: 'Liderança Inspiradora',
};

export const MoedaLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

export const MoedaTaskLabel: any = {
  uau_task: 'Arrasou',
  mandou_task: 'Top',
  valeu_task: 'Curti',
};

export function GetBehaviorDescription(key: string) {
  if (BehaviorDescription && BehaviorDescription[key]) {
    return BehaviorDescription[key];
  }
  return '';
}

export function GetBehaviorText(key: string) {
  if (BehaviorText && BehaviorText[key]) {
    return BehaviorText[key];
  }
  return '';
}

export function GetBehaviorTextDestaque(key: string) {
  if (BehaviorTextDestaque && BehaviorTextDestaque[key]) {
    return BehaviorTextDestaque[key];
  }
  return '';
}

export function GetBehaviorLabel(key: string) {
  if (BehaviorLabel && BehaviorLabel[key]) {
    return BehaviorLabel[key];
  }
  return '';
}

export function GetMoedaDescription(key: string) {
  if (MoedaDescription && MoedaDescription[key]) {
    return MoedaDescription[key];
  }
  return '';
}

export function GetMoedaLabel(key: string) {
  if (MoedaLabel && MoedaLabel[key]) {
    return MoedaLabel[key];
  }
  return '';
}

export const TaskStatusLabel: any = {
  waiting: 'Aguardando início',
  open: 'Envio de realizações',
  waiting_evaluation: 'Aguardando avaliação',
  evaluation: 'Em avaliação',
  closed: 'Encerrado',
};

export function GetTaskStatusLabel(key: string) {
  if (TaskStatusLabel && TaskStatusLabel[key]) {
    return TaskStatusLabel[key];
  }
  return key;
}

export const TaskLevelLabel: any = {
  aguardando: 'Aguardando validação',
  rejeitado: 'Devolvida',
  aprovado: 'Validada',
  concluido: 'Finalizada',
  concluidoAuto: 'Finalizada',
  apreciacaoExpirada: 'Prazo expirado',
  promovido: 'Indicada ao próximo nível',
  dobrado: 'Bonificada',
  selo: 'Indicado para Selo',
};

export function GetTaskLevelLabel(key: string) {
  if (TaskLevelLabel && TaskLevelLabel[key]) {
    return TaskLevelLabel[key];
  }
  return key;
}

type ManagerTypeProps = 'equipe' | 'solucoes' | 'pitstop' | 'executivo' | 'diretoria';
interface CheckManagerTypeProps {
  user: any;
  item: any;
  prefixo?: number;
  managerType?: ManagerTypeProps;
}

export function CheckManagerType({ user, item, prefixo }: CheckManagerTypeProps) {
  if (user.cod_etapa <= 0 || user.cod_etapa > 5) return undefined;

  if (item && item.prosseguir_gst) {
    const lastEvaluator =
      Array.isArray(item.evaluator) && item.evaluator.length ? item.evaluator[item.evaluator.length - 1] : undefined;

    if ((item.prosseguir_gst === 'next' || item.prosseguir_gst === 'stopped') && lastEvaluator && user._id === lastEvaluator) {
      return 'pitstop';
    }

    if (item.prosseguir_who_approved && item.prosseguir_who_approved === user._id) {
      return 'pitstop';
    }

    if (user.cod_etapa === 2) {
      return 'equipe';
    } else if (user.cod_etapa === 1 || user.cod_etapa === 3) {
      return 'solucoes';
    } else if (user.cod_etapa === 4) {
      return 'executivo';
    } else if (user.cod_etapa === 5) {
      return 'diretoria';
    }
  }

  if (user.cod_etapa === 2) {
    return 'equipe';
  } else if (user.cod_etapa === 1 || user.cod_etapa === 3) {
    return 'solucoes';
  } else if (user.cod_etapa === 4) {
    return 'executivo';
  } else if (user.cod_etapa === 5) {
    return 'diretoria';
  }

  // const equipe = [12083, 12060, 12080, 4725, 12070, 12071, 12423, 16280];
  // const solucoes = [
  //   16261, 16124, 16122, 16121, 16123, 16120, 16153, 16163, 16167, 12050, 12051,
  // ];
  // const executivo = [
  //   16145, 16065, 16051, 16025, 16050, 16041, 16034, 16035, 12010, 12020, 12011,
  // ];
  // const diretoria = [4007, 3003, 16010, 16022];

  // let funcao = user.cod_funcao;
  // let matricula = user.chave;

  // if (funcao === 16261 && prefixo === 8928) {
  //   return 'equipe';
  // } else if (funcao === 16163 && prefixo === 9210) {
  //   return 'equipe';
  // } else if (funcao === 16022 && prefixo === 9210) {
  //   return 'solucoes';
  // } else if (funcao === 12051 && matricula === 'F6002322' && prefixo !== 8559) {
  //   return 'diretoria';
  // } else if (equipe.includes(funcao)) {
  //   return 'equipe';
  // } else if (solucoes.includes(funcao)) {
  //   return 'solucoes';
  // } else if (executivo.includes(funcao)) {
  //   return 'executivo';
  // } else if (diretoria.includes(funcao)) {
  //   return 'diretoria';
  // }

  return undefined;
}

export const ManagerTypeLabel: any = {
  equipe: 'Gerente de Equipe',
  solucoes: 'Gerente de Soluções',
  pitstop: 'Gerente',
  executivo: 'Gerente Executivo',
  diretoria: 'Diretoria',
  selo: 'Selo',
};

export function GetManagerTypeLabel(key: string) {
  if (ManagerTypeLabel && ManagerTypeLabel[key]) {
    return ManagerTypeLabel[key];
  }
  return key;
}

export const ManagerStepLabel: any = {
  step2: 'Nível 2',
  step3: 'Nível 3',
  step4: 'Nível 4',
  step5: 'Nível 5',
};

export function GetManagerStepLabel(cod_etapa: number, status: string) {
  if (cod_etapa < 1 || cod_etapa > 5) {
    return '---';
  }

  if (cod_etapa === 3 || cod_etapa === 1) {
    if (typeof status === 'string' && (status === 'rejeitado' || status === 'aguardando')) {
      return ManagerStepLabel.step2;
    } else {
      return ManagerStepLabel.step3;
    }
  }

  return ManagerStepLabel[`step${cod_etapa}`];
}
